<template>
  <!-- <div :style="code==200?'':'height: calc(100vh - 108px);'"> -->
  <div>
    <template v-if="code==200">
      <b-row>
        <b-col md="6">
          <span
            style="font-size:19px !important;padding:0px 10px 1px 2px !important;position:relative;top:0px;"
            class="fw-semi-bold mt-1"
          >{{currency_code}} - Exchange Rates</span>
        </b-col>
        <b-col md="6" class="text-right">
          <b-button
            variant="primary"
            size="sm"
            @click="exchange_rate =createFreshData();error_msg = false"
            v-b-modal.exchange_rate_modal
          >Add Exchange Rate</b-button>
          <b-button
            variant="light"
            size="sm"
            class="mx-2"
            v-b-modal.exchangeratechange
          >{{exchange_status==1?'Enable Exchange rates':'Disable Exchange rates'}}</b-button>
          <b-button variant="light" size="sm" class="mr-2" :to="{name: 'Currency'}">
            <i class="la la-remove la-lg"></i>
          </b-button>
        </b-col>
      </b-row>
      <!-- Table for details -->
      <div class="table-responsive mt-4">
        <table class="table table-hover not-fixed-col not-fixed-last-col index-table">
          <thead>
            <tr>
              <th style="width:250px" class="text-left">
                <router-link
                  class="text-dark text-decoration-none"
                  :to="{ name : 'ExchangeRate',params:{id:$route.params.id},query: {sort:sort == 'asc' ? 'desc' : 'asc' ,label:'exchange_rate_date'} }"
                >
                  AS OF DATE
                  <small class="text-muted" v-if="label == 'created_date'">
                    <i :class="[{'fa fa-fw' : true},'fa-sort-'+sort]" style="font-weight:thinner;"></i>
                  </small>
                </router-link>
              </th>
              <th style="width:200px" class="text-right">EXCHANGE RATE</th>
              <th class="text-right"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="lists.length==0">
              <td
                colspan="3"
                class="text-center"
              >You have not specified any exchange rate for this currency</td>
            </tr>
            <tr v-for="(item,index) in lists" :key="index">
              <td>
                {{getDateFormat(item.exchange_rate_date)}}
                <b-badge
                  size="xs"
                  variant="success"
                  v-if="current_rate_id==item.exchange_rate_id"
                >Current Rate</b-badge>
              </td>
              <td
                class="text-right"
              >{{Number(item.exchange_rate).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 })}}</td>
              <td>
                <span
                  v-b-modal.deleteExchangeRate
                  @click="delete_id=item.exchange_rate_id"
                  class="ml-3 cursor_pointer fa fa-trash table-hover-visible"
                ></span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <ExchangeRate
        @success="recallData()"
        :currency_code="currency_code"
        :exchange_rate="exchange_rate"
      ></ExchangeRate>

      <b-modal
        :no-close-on-backdrop="true"
        id="exchangeratechange"
        size="md"
        body-class="bg-white"
        cancel-title="Cancel"
        cancel-variant="light"
        title="Change status exchange rate"
        ref="exchangeratechange"
        :ok-title-html="(submitted==true?loaderIcon:'')+(exchange_status==1?'Enable':'Disable')"
        @ok.prevent="exchangeRateStatus()"
        :ok-disabled="submitted"
      >
        <p
          v-if="exchange_status==0"
        >You will have to manually enter the exchange rates for each currency, if you disable this feature.</p>
        <p v-else>The exchange rates for the currencies will automatically be fetched as 1.</p>
      </b-modal>
      <b-modal
        :no-close-on-backdrop="true"
        id="deleteExchangeRate"
        size="md"
        body-class="bg-white"
        cancel-title="Cancel"
        cancel-variant="light"
        :ok-title-html="(submitted==true?loaderIcon:'')+'Yes'"
        title="Delete Currency"
        ref="deleteExchangeRate"
        @ok="deleteExchangeRate()"
        :ok-disabled="submitted"
      >
        <p>Are you sure about deleting this exchange rate?</p>
      </b-modal>
    </template>
    <template v-else>
      <b-row class="h-100 text-center mx-auto my-auto">
        <b-col class="mx-auto my-auto">
          <h6 class="text-muted h6-lg">
            <i
              class="la la-warning la-lg text-danger"
              style="font-size:40px;position: relative;top: 5px;"
            ></i>
            {{message}}
          </h6>
          <b-button variant="primary" size="sm" class="my-2" :to="{name: 'Currency'}">Go Back</b-button>
        </b-col>
      </b-row>
    </template>
  </div>
</template>
<script>
// import all the components, files and funciton
import { mapState, mapGetters } from "vuex"; // get data set in the state in vuex
import store from "@/store/index"; // vuex store fucntion
import { notificationMixin } from "@/mixins/notification"; // global function for calling notification
import vSelect from "vue-select";
import DatePicker from "vue2-datepicker"; // vue datepicker
import { formatDate } from "@/mixins/formatDate";
import ExchangeRate from "@/components/Modal/Currency/ExchangeRate"; // to excel export the output

function getPageList(routeTo, next) {
  const sort = routeTo.query.sort || "";
  const label = routeTo.query.label || "";
  store
    .dispatch("currency/fetchExRateLists", {
      id: routeTo.params.id,
      sort: sort,
      label: label
    })
    .then(() => {
      routeTo.params.sort = sort;
      routeTo.params.label = label;
      next();
    });
}
export default {
  components: { vSelect, DatePicker, ExchangeRate },
  mixins: [notificationMixin, formatDate], //call the global mixin function
  name: "ReportTag",
  props: { label: [String, Number], sort: [String, Number] },
  data() {
    return {
      delete_id: "",
      loaderIcon: `<i class="fa fa-circle-o-notch fa-spin mr-2"></i>`,
      submitted: false,
      exchange_rate: this.createFreshData(),
      error_msg: false,
      error_show: false,
      enable_exchange: false
    };
  },

  methods: {
    recallData() {
      store.dispatch("currency/fetchExRateLists", {
        id: this.$route.params.id,
        sort: this.sort,
        label: this.label
      });
    },
    createFreshData() {
      return {
        currency_id: this.$route.params.id,
        date: "",
        value: "",
        code: this.currency_code
      };
    },

    // delete exchange rate
    deleteExchangeRate() {
      this.submitted = true;
      this.$store
        .dispatch("currency/deleteExchangeRate", {
          id: this.delete_id
        })
        .then(() => {
          //to show the alert message for success or error after api call
          window.Messenger().post({
            extraClasses:
              "messenger-fixed messenger-on-top messenger-on-center",
            message: this.message,
            type: this.type,
            showCloseButton: true
          });
          this.recallData();
          this.submitted = false;
        });
    },
    // change exchange rate status
    exchangeRateStatus() {
      this.submitted = true;
      this.$store
        .dispatch("currency/exchangeRateStatus", {
          exchange_status: this.exchange_status == 0 ? 1 : 0
        })
        .then(() => {
          this.submitted = false;
          this.$refs.exchangeratechange.hide();
          window.Messenger().post({
            extraClasses:
              "messenger-fixed messenger-on-top messenger-on-center",
            message: this.message,
            type: this.type,
            showCloseButton: true
          });
          this.$router.push({ name: "Currency" });
        });
    }
  },
  //routing
  beforeRouteEnter(routeTo, routeFrom, next) {
    getPageList(routeTo, next);
  },
  beforeRouteUpdate(routeTo, routeFrom, next) {
    getPageList(routeTo, next);
  },
  //computed properties
  computed: {
    ...mapState({
      lists: state => state.currency.lists,
      exchange_status: state => state.currency.exchange_status,
      currency_code: state => state.currency.currency_code,
      current_rate_id: state => state.currency.current_rate_id,
      message: state => state.currency.message,
      type: state => state.currency.type,
      code: state => state.currency.code
    }),
    ...mapGetters(["orgCurrency"])
  }
};
</script>